import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["card"]
  static values = { url: String, interval: Number }

  connect() {
    this.interval = this.hasIntervalValue ? this.intervalValue : 8000
    this.rotating = false
    this.timer = setTimeout(() => this.startRotation(), this.interval)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
    if (this.rotationInterval) clearInterval(this.rotationInterval)
  }

  startRotation() {
    this.rotateRandomCard()
    this.rotationInterval = setInterval(() => {
      this.rotateRandomCard()
    }, this.interval)
  }

  async rotateRandomCard() {
    if (this.rotating || !this.hasCardTarget) return
    this.rotating = true

    const cards = this.cardTargets
    if (cards.length === 0) { this.rotating = false; return }

    // Pick a random card to rotate
    const index = Math.floor(Math.random() * cards.length)
    const card = cards[index]

    // Fade out
    card.classList.add("card-fading")

    // Wait for fade out
    await new Promise(r => setTimeout(r, 400))

    // Fetch a new card
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "text/html" }
      })

      if (response.ok) {
        const html = await response.text()
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")
        const newCards = doc.querySelectorAll(".library-horizontal-card")

        if (newCards.length > 0) {
          // Pick a random new card that's different from what's showing
          const currentNames = Array.from(cards).map(c =>
            c.querySelector(".task-card-heading strong")?.textContent?.trim()
          )

          let newCard = null
          const shuffled = Array.from(newCards).sort(() => Math.random() - 0.5)
          for (const candidate of shuffled) {
            const name = candidate.querySelector(".task-card-heading strong")?.textContent?.trim()
            if (!currentNames.includes(name)) {
              newCard = candidate
              break
            }
          }

          if (newCard) {
            // Preserve the data attribute
            newCard.setAttribute("data-card-rotator-target", "card")
            newCard.classList.add("card-fading")
            card.replaceWith(newCard)

            // Force reflow then fade in
            newCard.offsetHeight
            requestAnimationFrame(() => {
              newCard.classList.remove("card-fading")
            })
          } else {
            card.classList.remove("card-fading")
          }
        } else {
          card.classList.remove("card-fading")
        }
      } else {
        card.classList.remove("card-fading")
      }
    } catch (e) {
      card.classList.remove("card-fading")
    }

    this.rotating = false
  }
}
